<template>
  <div class="price">
    <div class="price__label" v-if="label">{{ label }}</div>
    <div class="price__value">{{ formattedValue }}</div>
  </div>
</template>

<script>
  export default {
    name: 'price',
    props: {
      label: {
        type: String,
      },
      value: {
        type: [Number, Boolean],
        required: true,
      },
      unit: {
        type: String,
        default: 'cent',
      },
      extraClasses: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      classes: function () {
        let classes = ['price']
        return classes.concat(this.extraClasses).join(' ')
      },
      formattedValue: function () {
        if (this.value === false) {
          return '-'
        }
        if (isNaN(parseFloat(this.value))) {
          return this.value
        }
        let value = (parseFloat(this.value) * 100).toFixed(2)
        value = (value + '').replace(/\./, ',')
        return `${value} ${this.$store.getters.str(`units.${this.unit}`)}`
      },
    },
  }
</script>

<style lang="scss" scoped>
  .price {
    transition: $transition-base;
    min-width: $price-min-width-min;

    @media (min-width: $bp-xs) {
      min-width: $price-min-width-xs;
    }

    @media (min-width: $bp-ssm) {
      min-width: $price-min-width-ssm;
    }

    &__label {
      font-size: $font-size-sm;
      color: $grey-dark;
      line-height: $line-height-sm;
    }

    &__value {
      line-height: $line-height-sm;

      @media (min-width: $bp-xs) {
        font-size: $font-size-lg;
      }

      @media (min-width: $bp-md) {
        font-size: $font-size-xl;
        margin-top: spacer(0.1);
      }
    }
  }
</style>
